import React from 'react';
import { BookOpenCheckIcon, MicroscopeIcon, StethoscopeIcon } from 'lucide-react';
import { CtaBlock } from './CtaBlock';
const credentials = [{
  icon: StethoscopeIcon,
  title: 'Pratica clinica',
  text: 'Esperienza nella valutazione della salute ormonale maschile e della TRT.'
}, {
  icon: MicroscopeIcon,
  title: 'Metodo basato sull’evidenza',
  text: 'Linee guida cliniche riconosciute e letteratura scientifica organizzate in percorsi consultabili.'
}, {
  icon: BookOpenCheckIcon,
  title: 'Progettato per la pratica reale',
  text: 'Ogni protocollo è pensato per essere aperto durante una visita, non solo studiato in teoria.'
}];
export function Author() {
  return <section className="bg-white py-14 sm:py-20" data-id="element-21" data-mp="xhgbaxdtnwyv">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-22" data-mp="xkauymp0hdr8">
        <div className="grid items-center gap-8 lg:grid-cols-[0.85fr_1.15fr] lg:gap-12" data-id="element-23" data-mp="3d82gtdriiqds">
          <figure className="mx-auto w-full max-w-sm" data-id="element-24" data-mp="3i9i3195ff2xr">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/3959bd8f-c85d-44e9-8ec4-7150fca4dd4b.jpg" alt="Dra. Karito, medico e autrice del Sistema Maestro della TRT™" className="w-full rounded-2xl object-cover shadow-[0_24px_50px_-30px_rgba(7,20,41,0.8)]" width={928} height={1160} loading="lazy" data-id="element-25" data-mp="1tyk5b1xlc71f" />
            <figcaption className="mt-3 text-center text-[11px] font-bold uppercase tracking-[0.14em] text-navy-900/55" data-id="element-26" data-mp="2cwwh6vfvzv0p">
              Dra. Karito — medico e autrice del sistema
            </figcaption>
          </figure>

          <div data-id="element-27" data-mp="2loopazhfus24">
            <span className="inline-block rounded-full bg-navy-900 px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.18em] text-gold-300" data-id="element-28" data-mp="2lp896lqnfqis">
              Chi c’è dietro il sistema
            </span>
            <h2 className="mt-4 text-[26px] font-black uppercase leading-[1.1] tracking-tight text-navy-900 sm:text-4xl" data-id="element-29" data-mp="2vo783clm47sl">
              Chi è la Dra. Karito?
            </h2>

            <p className="mt-4 text-[15px] leading-relaxed text-navy-900/70" data-id="element-30" data-mp="1ocpy45fkuu8l">
              Ha creato il Sistema Maestro della TRT™ partendo dalla stessa
              frustrazione che molti clinici conoscono bene: le informazioni
              esistono, ma sono sparse tra linee guida, studi e appunti
              personali — raramente organizzate nel momento in cui servono
              davvero.
            </p>
            <p className="mt-3 text-[15px] leading-relaxed text-navy-900/70" data-id="element-31" data-mp="271eimqa5exju">
              Per questo ha ricostruito l’intero processo come un vero flusso di
              lavoro: diagnosi, interpretazione ormonale, scelta del
              trattamento, fertilità, pazienti complessi e monitoraggio a lungo
              termine.
            </p>

            <div className="mt-6 space-y-3" data-id="element-32" data-mp="lothbckbei6k">
              {credentials.map(item => <div key={item.title} className="flex gap-3 rounded-xl border border-navy-900/10 bg-navy-50/60 p-4" data-id="element-33" data-mp="qno6cw8vl2z4">
                  <item.icon className="mt-0.5 h-5 w-5 shrink-0 text-gold-600" aria-hidden="true" data-id="element-34" data-mp="j688avlxgcoe" />
                  <div data-id="element-35" data-mp="9fdlnq4rrb2f">
                    <h3 className="text-[13px] font-black uppercase tracking-tight text-navy-900" data-id="element-36" data-mp="9eve3xcnpaf7">
                      {item.title}
                    </h3>
                    <p className="mt-1 text-[13px] leading-relaxed text-navy-900/70" data-id="element-37" data-mp="123j6ecvtp029">
                      {item.text}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        <div className="mt-10 flex justify-center" data-id="element-38" data-mp="s30hh3peitdh">
          <CtaBlock label="Ottieni il sistema della Dra. Karito" note="6 volumi · 5 bonus · 19 EUR" data-id="element-39" data-mp="o3zz1mau5sr0" />
        </div>
      </div>
    </section>;
}